module.exports = __webpack_public_path__ + "img/comprehensive1.cab31617.png";